import {
  TRESPONSE_GET_LINE_SETUP_TICKET_CURRENT_SETUP,
  TRESPONSE_LINE_SETUP_TICKET_DETAILS,
  TRESPONSE_LINE_SETUP_TICKET_LISTING,
  TRESPONSE_LINE_SETUP_TICKET_SUBTASK_LIST,
  TUserPaginationOption,
} from '@monorepo/types';

export const LINE_SETUP_TICKET_DEFAULT_PAGINATION_OPTION: TUserPaginationOption = { pageNo: 1, pageSize: 10 };

export interface TQcoState {
  lineSetupTicketsListing: TRESPONSE_LINE_SETUP_TICKET_LISTING | null;
  lineSetupSubtasksListing: TRESPONSE_LINE_SETUP_TICKET_SUBTASK_LIST | null;
  lineSetupTicketNewSetupDetails: TRESPONSE_LINE_SETUP_TICKET_DETAILS | null;
  lineSetupTicketCurrentSetupDetails: TRESPONSE_GET_LINE_SETUP_TICKET_CURRENT_SETUP | null;
  lineSetupTicketPaginationOption: TUserPaginationOption;
}

export const TQcoActionTypes = {
  GetLineSetupTicketsListing: 'GET_LINE_SETUP_TICKETS_LISTING' as const,
  GetLineSetupTicketsListingSuccess: 'GET_LINE_SETUP_TICKETS_LISTING_SUCCESS' as const,
  GetLineSetupTicketsListingFailure: 'GET_LINE_SETUP_TICKETS_LISTING_FAILURE' as const,
  GetLineSetupTicketsSubtasks: 'GET_LINE_SETUP_TICKETS_SUBTASKS' as const,
  GetLineSetupTicketsSubtasksSuccess: 'GET_LINE_SETUP_TICKETS_SUBTASKS_SUCCESS' as const,
  GetLineSetupTicketsSubtasksFailure: 'GET_LINE_SETUP_TICKETS_SUBTASKS_FAILURE' as const,
  FetchLineSetupTicketNewSetup: 'FETCH_LINE_SETUP_TICKET_NEW_SETUP' as const,
  FetchLineSetupTicketNewSetupSuccess: 'FETCH_LINE_SETUP_TICKET_NEW_SETUP_SUCCESS' as const,
  FetchLineSetupTicketNewSetupFailure: 'FETCH_LINE_SETUP_TICKET_NEW_SETUP_FAILURE' as const,
  FetchLineSetupTicketCurrentSetup: 'FETCH_LINE_SETUP_TICKET_CURRENT_SETUP' as const,
  FetchLineSetupTicketCurrentSetupSuccess: 'FETCH_LINE_SETUP_TICKET_CURRENT_SETUP_SUCCESS' as const,
  FetchLineSetupTicketCurrentSetupFailure: 'FETCH_LINE_SETUP_TICKET_CURRENT_SETUP_FAILURE' as const,
  SetLineSetupTicketPaginationOption: 'SET_LINE_SETUP_TICKET_PAGINATION_OPTION' as const,
};
